import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { selectCurrentUser, selectIsCreditUser } from 'Douleutaras/redux/data/auth/authSlice';
import { getAbsoluteUrl } from 'Douleutaras/utilities/url-builder';

import './CreditButton.scss';

export const CreditButton = ({inDropDown = false}) => {
  const { t } = useTranslation();
  const user = useAppSelector(selectCurrentUser);
  const isCreditUser = useAppSelector(selectIsCreditUser);

  if (!isCreditUser) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  return (
    <div styleName={inDropDown ? 'dropdown-item' : 'dashboard-header-credit'}>
      <div styleName="credit-button">
        <Link to={getAbsoluteUrl('PRO_DASHBOARD.SETTINGS.PLANS.ROOT')}
              styleName="credit-button__inner">
          <div styleName="credit-button__icon" className="dashicon dashicon-coinse" />
          <div styleName="credit-button__content">
            <div styleName="credit-button__balance">
              {t('T.HEADER.CREDIT-BALANCE')}: {user.stats.credits}
            </div>
            <div styleName="credit-button__text">
              {t('T.HEADER.BUY-CREDIT')}
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};
